import type { TareaArtifact } from '@/lib/types'
import { sanitizeHtml, processContent } from '@/lib/utils'
import { IconX } from '@/components/icons/Icons'

interface Props {
  artifact: TareaArtifact
  onClose: () => void
}

const HTML_PATTERN = /^\s*<|<(div|p|h[1-6]|ul|ol|table|section|article|span|br|img)\b/i

function isHtmlContent(text: string): boolean {
  return HTML_PATTERN.test(text)
}

export default function ArtifactViewer({ artifact, onClose }: Props) {
  if (artifact.tipo !== 'canvas' || !artifact.contenido_raw) return null

  const raw = artifact.contenido_raw
  const isHtml = isHtmlContent(raw)

  return (
    <div className="artifact-viewer">
      <div className="artifact-viewer__header">
        <h4 className="artifact-viewer__title">{artifact.nombre}</h4>
        <button
          type="button"
          className="artifact-viewer__close"
          onClick={onClose}
          aria-label="Cerrar visor"
        >
          <IconX size={16} />
        </button>
      </div>

      <div className="artifact-viewer__body">
        {isHtml ? (
          <div
            className="artifact-viewer__content artifact-viewer__content--html"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(processContent(raw)),
            }}
          />
        ) : (
          <pre className="artifact-viewer__content artifact-viewer__content--text">
            {raw}
          </pre>
        )}
      </div>
    </div>
  )
}
